import { tv } from "../../variants/tv.js";
const promoCodeVariants = tv({
    slots: {
        root: 'relative inline-flex cursor-pointer items-center justify-start overflow-visible rounded-full antialiased outline-1 outline-offset-2 transition-colors outline-dashed select-none [perspective:1200px]',
        codeWrapper: 'relative flex',
        codeBadge: 'relative inline-flex items-center justify-center rounded-full leading-none font-bold whitespace-nowrap text-primary-11 transition-opacity',
        balloonOverlay: 'pointer-events-none absolute inline-flex [transform-origin:center] items-center justify-center rounded-full border border-primary-5 bg-neutral-1 leading-none font-extrabold whitespace-nowrap text-primary-11 opacity-0 [will-change:transform,box-shadow,background-color,opacity] [transform-style:preserve-3d]',
        balloonText: 'pointer-events-none relative inline-block text-primary-11',
        codeText: 'pointer-events-none inline-block',
        glossHighlight: 'pointer-events-none absolute top-[20%] left-[15%] h-1/4 w-1/2 [transform:translateZ(2px)] rounded-full opacity-0 blur-[2px] [background:radial-gradient(circle,rgba(255,255,255,0.8)_0%,transparent_70%)]',
        copyLabel: 'relative flex items-center justify-end font-bold transition-opacity'
    },
    variants: {
        size: {
            sm: {
                root: 'gap-1 p-1',
                codeBadge: 'h-5 px-2 text-body3',
                balloonOverlay: 'h-5 px-2 text-body3',
                copyLabel: 'mr-2 min-w-9 text-body3'
            },
            md: {
                root: 'gap-1 p-1',
                codeBadge: 'h-6 px-2 text-body2',
                balloonOverlay: 'h-6 px-2 text-body2',
                copyLabel: 'mr-2 min-w-10 text-body2'
            }
        },
        emphasis: {
            regular: {
                root: 'bg-primary-1 outline-primary-7 transition ease-in hover:outline-primary-8 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-8 focus-visible:outline-solid',
                codeBadge: 'text-primary-11',
                balloonOverlay: 'text-primary-11',
                copyLabel: 'text-primary-8 hover:text-primary-9'
            },
            medium: {
                root: 'bg-primary-3 outline-primary-8 transition ease-in hover:bg-primary-4 hover:outline-primary-9 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-8 focus-visible:outline-solid',
                codeBadge: 'text-primary-11',
                balloonOverlay: 'text-primary-11',
                copyLabel: 'text-primary-8 hover:text-primary-9'
            },
            bold: {
                root: 'bg-primary-11 outline-primary-8 transition ease-in hover:bg-primary-12 hover:outline-primary-11 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-8 focus-visible:outline-solid',
                codeBadge: 'text-primary-1',
                balloonOverlay: 'text-primary-11',
                copyLabel: 'text-primary-1 hover:underline'
            }
        },
        fullWidth: {
            true: {
                root: 'w-full justify-center'
            }
        }
    },
    defaultVariants: {
        size: 'md',
        emphasis: 'regular'
    }
});
const promoCodeSizes = Object.keys(promoCodeVariants.variants.size);
const promoCodeEmphases = Object.keys(promoCodeVariants.variants.emphasis);
export { promoCodeEmphases, promoCodeSizes, promoCodeVariants };
